import { useState } from 'react'

export default function AccountForm({ account, onSubmit, onCancel, loading }) {
  const [formData, setFormData] = useState({
    name: account?.name || '',
    internal_identifier: account?.internal_identifier || '',
    domain: account?.domain || '',
    default_expiry_hours: account?.default_expiry_hours || '',
    default_expiry_redirect_url: account?.default_expiry_redirect_url || '',
    is_deleted: false
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit({
      ...formData,
      domain: formData.domain || null,
      default_expiry_hours: formData.default_expiry_hours ? parseInt(formData.default_expiry_hours, 10) : null,
      default_expiry_redirect_url: formData.default_expiry_redirect_url || null,
    })
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Account Name <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
          className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500 focus:border-transparent"
          placeholder="e.g., Marketing Links"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Internal Identifier <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="internal_identifier"
            value={formData.internal_identifier}
            onChange={handleChange}
            required
            className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500 focus:border-transparent"
            placeholder="e.g., marketing-links"
          />
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Unique identifier for API lookups
          </p>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Domain
          </label>
          <input
            type="text"
            name="domain"
            value={formData.domain}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500 focus:border-transparent"
            placeholder="e.g., go.example.com"
          />
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Custom domain for short URLs (requires DNS setup)
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Default Expiry Hours
          </label>
          <input
            type="number"
            name="default_expiry_hours"
            value={formData.default_expiry_hours}
            onChange={handleChange}
            min="1"
            className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500 focus:border-transparent"
            placeholder="e.g., 720 (30 days)"
          />
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Default TTL in hours for new short URLs. Leave empty for no expiry.
          </p>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Default Expiry Redirect URL
          </label>
          <input
            type="url"
            name="default_expiry_redirect_url"
            value={formData.default_expiry_redirect_url}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500 focus:border-transparent"
            placeholder="https://example.com/expired"
          />
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Fallback redirect when a short URL expires
          </p>
        </div>
      </div>

      <div className="flex justify-end space-x-3 pt-4">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600"
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={loading}
          className="px-4 py-2 text-white bg-primary-500 rounded-lg hover:bg-primary-600 disabled:opacity-50"
        >
          {loading ? 'Saving...' : account ? 'Update' : 'Create'}
        </button>
      </div>
    </form>
  )
}
